<template>
  <div class="add-student">
    <el-form
      v-if="showPage"
      class="setp-form"
      ref="step1form"
      :rules="rules"
      :model="form"
      label-width="145px"
      size="small"
    >
      <el-form-item label="活动主题" prop="actTitle">
        <el-input
          v-model="form.actTitle"
          style="width: 400px"
          maxlength="20"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="活动时间" prop="allDate">
        <el-date-picker
          v-model="form.allDate"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="活动地点" prop="address">
        <el-input v-model="form.address" style="width: 400px"></el-input>
      </el-form-item>
      <el-form-item label="学生名单" prop="studentList">
        <el-button type="text" @click="onShowDialog">添加</el-button>
        <span style="margin-left: 10px">共{{ form.studentList.length }}人</span>
        <div class="space"></div>
        <el-tag
          color="#f1fddc"
          size="small"
          v-for="tag in form.studentList"
          :key="tag.id"
          :disable-transitions="false"
          closable
          @close="handleDel(tag)"
          style="margin-left: 12px; padding: 0 8px; color: #81b337"
          >{{ tag.gradeName }}{{ tag.className }}&nbsp;&nbsp;{{
            tag.studentName
          }}</el-tag
        >
      </el-form-item>
      <el-form-item label="活动内容" prop="actContent">
        <el-input
          v-model="form.actContent"
          style="width: 600px"
          maxlength="200"
          show-word-limit
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          placeholder="请输入研究内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="活动素材" prop="materialAttaches">
        <uploader
          style="display: inline-block"
          :multiple="true"
          :limit="10"
          accept=".png, .jpg, .jpeg, .mp4"
          :maxSize="30 * 1024 * 1024"
          :file-list.sync="form.materialAttaches"
        />
      </el-form-item>
      <el-form-item label="活动封面" prop="faceAttaches">
        <face v-model="form.faceAttaches"></face>
      </el-form-item>
      <div>
        <el-button
          :loading="btnLoading"
          class="sub-form"
          size="small"
          @click="submitForm"
          type="primary"
          >发 布</el-button
        >
      </div>
    </el-form>
    <!-- 成员导师 -->
    <el-dialog
      title="添加学生"
      :visible.sync="isShowDialog"
      center
      destroy-on-close
      width="80%"
      :before-close="handleClose"
    >
      <el-form class="full-width" :model="filterFrom">
        <div
          class="filter-bar mb-sm"
          type="flex"
          style="flex-direction: column"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item class="mb-none">
                <el-input
                  size="small"
                  v-model="filterFrom.keyword"
                  clearable
                  placeholder="搜索"
                  @input="refresh"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="filter-row mb-2px">
                <!-- <grade-selector
                  v-model="filterFrom.grade"
                  @change="gradeChange"
                ></grade-selector> -->
                <el-select
                  v-model="filterFrom.grade"
                  placeholder="请选择年级"
                  value-key="grade"
                  @change="gradeChange"
                >
                  <el-option
                    v-for="item in gradeOptions"
                    :key="item.gradeName"
                    :label="item.gradeName"
                    :value="item.grade"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="filter-row mb-2px">
                <el-select
                  v-model="filterFrom.classCode"
                  placeholder="请选择班级"
                  value-key="classCode"
                  @change="onChangeClass"
                  clearable
                >
                  <el-option
                    v-for="item in classOptions"
                    :key="item.classCode"
                    :label="item.className"
                    :value="item.classCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="space student-list">
            <ul class="infinite-list" style="overflow: auto">
              <el-checkbox-group
                v-model="studentCheckedList"
                size="small"
                text-color="#81b337"
                fill="#f1fddc"
              >
                <el-checkbox-button
                  v-for="student in allStudentList"
                  :label="student.studentId"
                  :key="student.studentId"
                  >{{ student.gradeName }}&nbsp;{{
                    student.className
                  }}&nbsp;&nbsp;{{ student.studentName }}</el-checkbox-button
                >
              </el-checkbox-group>
            </ul>
          </div>
          <div class="student-list">
            <h4>
              已选择学生&nbsp;&nbsp;&nbsp;&nbsp;
              {{ checkList.length }}人
            </h4>
            <ul class="infinite-list checked-list" style="overflow: auto">
              <li v-for="(student, i) in checkList" :key="student.studentId">
                {{ student.gradeName }}&nbsp;{{
                  student.className
                }}&nbsp;&nbsp;{{ student.studentName }}
              </li>
            </ul>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOk3">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState, mapGetters } from "vuex";
import Face from "@/components/common/Face.vue";
import DicCodeSelector from "@/components/common/DicCodeSelector.vue";
import gradeSelector from "@/components/school/gradeSelector.vue";
import uploader from "@/components/school/uploader.vue";
export default {
  components: {
    Face,
    DicCodeSelector,
    gradeSelector,
    uploader,
  },
  computed: {
    ...mapState(["userInfo", "schoolList", "topicLink"]),
    ...mapGetters(["schoolCodes"]),
    orgOptions: function () {
      let orgList = [
        {
          orgCode:
            this.userInfo.teacherSchoolList[0].orgCode ||
            this.userInfo.teacherSchoolList[0].schoolCode,
          orgName:
            this.userInfo.teacherSchoolList[0].orgName ||
            this.userInfo.teacherSchoolList[0].schoolName,
        },
      ];
      return orgList;
    },
    checkList() {
      let that = this;
      return this.allStudentListD.filter((item) =>
        that.studentCheckedList.includes(item.studentId)
      );
    },
  },
  data() {
    return {
      showPage: false,
      btnLoading: false,
      contentId: "",
      form: {
        actTitle: "", //项目课题研究主题
        allDate: [], //startDate:"",endDate:"",
        startDate: "",
        endDate: "",
        operatorId: "",
        studentList: [], //主讲人
        actContent: "", //活动内容
        faceAttaches: [], //封面
        orgCode: "", //集团代码
        schoolCode: "", //校区代码
        address: "", //活动地址
        studentList: [],
        materialAttaches: [],
      },
      classOptions: [],
      gradeOptions: [],
      allStudentList: [],
      allStudentListD: [],
      studentCheckedList: [],
      filterFrom: {
        keyWords: "",
        classCode: "",
        grade: "",
        schoolCode: "",
        schoolYear: "",
      },
      isShowDialog: false,
      rules: {
        actTitle: [
          {
            required: true,
            message: "请输入活动主题",
            trigger: "blur",
          },
        ],
        allDate: [
          {
            required: true,
            message: "请选择项目课题研究时间",
            trigger: "change",
          },
        ],
        // materialAttaches: [
        //   {
        //     required: true,
        //     message: "请选择项目课题研究时间",
        //     trigger: "change",
        //   },
        // ],
        address: [
          {
            required: true,
            message: "请输入活动地点",
            trigger: "blur",
          },
        ],
        actContent: [
          {
            required: true,
            message: "请输入活动内容",
            trigger: "blur",
          },
        ],
        faceAttaches: [
          { required: true, message: "选择项目活动封面", trigger: "blur" },
        ],
        studentList: [
          {
            required: true,
            message: "请添加学生名单",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      // this.showPage = false;
      //回显
      if (sessionStorage.getItem("actCode")) {
        let activeInfo = await getData("/moral/getMoralActivityInfoDetail", {
          actCode: sessionStorage.getItem("actCode"),
          operatorId: this.userInfo.userId,
        });
        this.form = { ...activeInfo };
        this.form.studentList = activeInfo.activeUserMapDTOS;
        if (
          activeInfo.activeUserMapDTOS &&
          activeInfo.activeUserMapDTOS.length > 0
        ) {
          activeInfo.activeUserMapDTOS.forEach((item) => {
            if (
              this.allStudentListD.findIndex(
                (student) => student.studentId == item.studentId
              ) == -1
            ) {
              this.allStudentListD.push(item);
            }
          });
        }

        //封面从资源删除后会没有次字段  导致效验不通过
        if (!activeInfo.faceAttaches) {
          this.$set(this.form, "faceAttaches", []);
        }
        // 回显附件的url地址
        if (
          activeInfo.materialAttaches &&
          activeInfo.materialAttaches.length > 0
        ) {
          this.form.materialAttaches = this.form.materialAttaches.map(
            (item) => ({ ...item, url: item.attachUrl })
          );
        }

        this.$set(this.form, "allDate", [
          activeInfo.startDate,
          activeInfo.endDate,
        ]);
      } else {
        let CurrentSemester = await getData("/school/getCurrentSemester", {
          schoolCode: this.userInfo.schoolCode,
        });
        await postData("/planning/getTeacherMentorInfo", {
          schoolYear: CurrentSemester.schoolYear,
          teacherId: this.userInfo.userId,
          schoolCode: this.userInfo.schoolCode,
        })
          .then((res) => {
            if (res.isMentor == 0) {
              this.form.studentList = [];
            }
            if (res.studentList && res.studentList.length > 0) {
              this.form.studentList = res.studentList;
              res.studentList.forEach((item) => {
                if (
                  this.allStudentListD.findIndex(
                    (student) => student.studentId == item.studentId
                  ) == -1
                ) {
                  this.allStudentListD.push(item);
                }
              });
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
      this.showPage = true;
    },

    async submitForm() {
      try {
        this.btnLoading = true;
        await this.$refs.step1form.validate();
        this.form.schoolCode = this.userInfo.schoolCode;
        this.form.operatorId = this.userInfo.userId;
        if (!this.form.orgCode) {
          this.form.orgCode = this.orgOptions[0].orgCode;
        }
        await postJson("/moral/saveOrUpdateMoralActivityInfo", this.form);
        this.btnLoading = false;
        this.$message.success("发布成功！");
        this.$router.push({ name: "moralResearch" });
      } catch (err) {
        console.log("err", err);
        this.btnLoading = false;
      }
    },
    resetForm() {
      this.$refs.step1form.resetFields();
    },
    refresh() {
      this.getStudentListByCodes();
    },
    handleDel(tag) {
      this.form.studentList = this.form.studentList.filter(
        (item) => item.studentId != tag.studentId
      );
      this.$forceUpdate();
    },
    async onShowDialog() {
      await postData("/school/getGradeList", {
        schoolCode: this.userInfo.schoolCode,
      })
        .then((res) => {
          let list = [];
          if (res.length) {
            list = res;
            this.gradeOptions = res;
            this.filterFrom.grade = res[0].grade;
          } else {
            this.gradeOptions = [];
          }
        })
        .catch((e) => {
          reject(e);
        })
        .finally(() => {});
      this.gradeChange(this.filterFrom.grade);
      this.isShowDialog = true;
      this.filterFrom.classCode = "";
      this.filterFrom.keyWords = "";
      this.filterFrom.schoolCode = this.userInfo.schoolCode;
      this.filterFrom.teacherId = this.userInfo.userId;
      this.filterFrom.schoolYear = this.schoolYear;
      await this.getStudentListByCodes();
      if (this.form.studentList.length > 0) {
        this.studentCheckedList = this.form.studentList.map(
          (item) => item.studentId
        );
      }
    },
    handleClose() {
      this.isShowDialog = false;
      this.studentCheckedList = [];
    },
    async getStudentListByCodes() {
      let res = await postJson(
        "/planning/getStudentListByCodes",
        this.filterFrom
      );
      this.allStudentList = res;
      if (res.length > 0) {
        res.forEach((item) => {
          if (
            this.allStudentListD.findIndex(
              (student) => student.studentId == item.studentId
            ) == -1
          ) {
            this.allStudentListD.push(item);
          }
        });
      }
    },
    async gradeChange(val) {
      this.filterFrom.classCode = "";
      // this.filterFrom.grade = val.grade;
      this.classOptions = await getData("/school/getClassInfoList", {
        schoolCode: this.userInfo.schoolCode,
        grade: val,
        pageSize: -1,
        pageNum: 1,
      });
      this.getStudentListByCodes();
    },
    async onChangeClass(val) {
      // this.filterFrom.classCode = val.classCode;
      await this.getStudentListByCodes();
    },
    addOk3() {
      this.isShowDialog = false;
      if (this.checkList.length > 0) {
        this.checkList.forEach((item, index) => {
          if (
            this.form.studentList.findIndex(
              (student) => student.studentId == item.studentId
            ) == -1
          ) {
            this.form.studentList.push(item);
          }
        });
        this.studentCheckedList = [];
      }
    },
  },
  watch: {
    "form.allDate": {
      handler(val, oldVal) {
        if (val.length > 0) {
          this.form.startDate = val[0];
          this.form.endDate = val[1];
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.setp-form {
  padding-top: 15px;
  padding-bottom: 30px;
  width: 830px;
  margin: 0 auto;
}

.sub-form {
  margin-top: 30px;
  margin-left: 380px;
}

.scorll-list {
  padding: 2px;
  border: 1px solid rgb(231, 227, 227);
  border-radius: 5px;
  min-height: 30px;
  max-height: 128px;
  overflow: auto;

  .el-tag {
    margin: 3.5px;
    padding: 0px 5px;
  }
}

.box-active-content {
  position: relative;
  left: 0px;
  top: 0px;
  width: 610px;
  margin-top: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid rgb(212, 208, 208);
  padding: 15px 0px;
  padding-bottom: 0px;

  .content-del {
    position: absolute;
    right: -35px;
    top: 0px;
    font-size: 20px;
    padding: 5px;
  }

  .content-plus {
    position: absolute;
    right: -35px;
    top: 35px;
    font-size: 20px;
    padding: 5px;
  }

  .el-divider--horizontal {
    margin: 0px 0px 15px 0px;
  }

  .addlink {
    border: 1px solid @color;
    color: @color;
    padding: 6px 10px;
  }
}

/deep/.link-pop .el-dialog {
  border-radius: 20px;

  .add-content {
    padding: 0px 20px;

    h2 {
      font-size: 17px;
      font-weight: 700;
      margin-bottom: 25px;
    }

    span {
      cursor: pointer;
      vertical-align: middle;
      display: inline-block;
      width: 170px;
      color: @color;
      border-radius: 5px;
      background: #eee;
      padding: 12px 17px;
      font-size: 16px;
      margin-right: 35px;
      margin-bottom: 35px;

      em {
        color: rgb(59, 58, 58);
        margin-left: 15px;
      }

      i {
        vertical-align: middle;
        font-weight: 700;
        font-size: 20px;
      }

      i:nth-of-type(2) {
        font-size: 21px;
      }
    }
  }
}

.link-ul {
  margin-top: 10px;
  padding-left: 0px;

  li {
    border-radius: 8px;
    padding: 0px 10px;
    cursor: pointer;
    border: 1px solid #dfd6d6;

    span {
      margin-top: 13px;
      border: 2px solid @color;
      color: @color;
      height: 28px;
      width: 28px;
      font-size: 20px;
      border-radius: 50%;
      text-align: center;
      line-height: 20px;
    }

    .desc {
      h1 {
        font-size: 15px;
        padding-left: 10px;
      }

      h2 {
        margin-top: 0px;
        font-size: 13px;
        height: 22px;
        line-height: 17px;
        padding-left: 10px;
        color: @hui;

        i {
          color: @color;
          font-size: 15px;
        }
      }
    }

    .edit-but {
      margin-left: 100px;
      margin-right: 80px;
      margin-top: 14px;
    }

    .del-but {
      margin-right: 50px;
      color: @hong;
    }
  }
}
.add-student {
  .student-list {
    width: 100%;
    flex: 50%;

    .infinite-list {
      padding: 0;
      margin: 0;
      max-height: 500px;

      .el-checkbox-group {
        display: grid;
        grid-template-columns: 20% 20% 20% 20% 20%;
        // flex-wrap: wrap;
        // justify-content: space-around;
        // > label {
        //   width: 12%;
        //   margin-top: 30px;
        // }
      }
    }
    .checked-list {
      display: grid;
      grid-template-columns: 20% 20% 20% 20% 20%;
      li {
        display: inline-block;
        padding: 9px 15px;
        font-size: 12px;
        border-radius: 0;
        color: #81b337;
        background-color: #f1fddc;
        display: inline-block;
        line-height: 1;
        font-weight: 500;
        white-space: nowrap;
        vertical-align: middle;
        border: 1px solid #dcdfe6;
        border-left: 0;
        margin: 5px;
      }
    }
  }
}
</style>
